import modalStyle from '..//org-management-modal.module.scss';

import { Row, Col } from 'react-bootstrap';
import Input from 'components/Input';
import Button from 'components/Button';
import ModalContainer from 'components/ModalContainer';
import DropdownWithItem from 'components/DropdownWithItem';
import MessageBoxGroup from 'components/MessageBoxGroup';
import SpinnerForModal from "ui/SpinnerForModal";

import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { cloneDeep, size, isNil } from 'lodash';
import validator from "validator";

import { uiActions, selectShowModalSpinner } from "stores/slice/ui";
import usePageContext from "hooks/usePageContext";

import storeTagService from 'services/Auth.StoreTag.service';

import { defaultMessages } from "../const";
import modalController from "./modalController"

const defaultData = {
  name: {
    value: '',
    isInvalid: false
  },
  organizationId: '',
  storeTag: {}
}

const OrgManagementSiteTagModal = ({
  info,
  modalStatus,
  handleModals,
  submitModal
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showModalSpinner = useSelector(selectShowModalSpinner);
  const { getManagedSiteTagList } = usePageContext();
  const { pageContext } = useSelector((store) => store);

  const [multiMessages, setMultiMessages] = useState(cloneDeep(defaultMessages));
  const [modalInfo, setModalInfo] = useState({});
  const [modalData, setModalData] = useState(cloneDeep(defaultData));
  const [tagList, setTagList] = useState([]);

  const init = async () => {
    try {
      dispatch(uiActions.showModalSpinner());
      await initModalInfo()
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(uiActions.hideModalSpinner());
    }
  }

  const initModalInfo = async () => {
    const editObj = modalStatus.tag.editObj
    const tmp = {
      isCreate: modalStatus.tag.type === 'create' ? true : false,
      organizationId: editObj.orgId || editObj.id,
    }
    if (!info.isOrgUser) {
      if (pageContext.selectedOrg && pageContext.selectedOrg.id === tmp.organizationId) {
        tmp.targetOrg = pageContext.selectedOrg
      } else {
        const { selectedOrg } = await modalController.getSelectedOrg({ id: tmp.organizationId })
        tmp.targetOrg = selectedOrg
      }
    } else {
      tmp.targetOrg = pageContext.selectedOrg
    }

    const list = await getTagOption(tmp)
    const defData = cloneDeep(defaultData)
    if (tmp.isCreate) {
      defData.storeTag = list[0]
      setTagList(list)
    } else {
      tmp.targetTag = tmp.targetOrg.storeTagObj[editObj.id]
      const { parentTag, newTagList } = findParentTag(tmp, list)
      defData.storeTag = size(parentTag) > 0 ? parentTag[0] : list[0]
      defData.name.value = tmp.targetTag.name
      setTagList(newTagList)
    }
    setModalInfo(tmp)
    setModalData(defData)
  }

  const findParentTag = (tmp, list) => {
    const parentTag = list.filter(item => item.value === tmp.targetTag.parentStoreTagId)
    const newTagList = cloneDeep(list)
    if (size(parentTag) > 0) {
      newTagList.map(function (item) {
        item.isActive = item.value === parentTag[0].value ? true : false
        return item
      });
    }
    return { parentTag, newTagList }
  }

  const getTagOption = async (tmp) => {
    let list = []
    if (info.isOrgUser)
      list = modalController.getAllTagList(getManagedSiteTagList())
    else
      if (pageContext.selectedOrg && pageContext.selectedOrg.id === tmp.organizationId)
        list = modalController.getAllTagList(tmp.targetOrg.storeTagObj)
      else
        list = modalController.getAllTagList(tmp.targetOrg.storeTagObj)

    return list
  }

  const changeTag = (target) => {
    const copy = cloneDeep(tagList)
    copy.map(function (item) {
      item.isActive = item.value === target.value ? true : false
      return item
    });
    setModalData({ ...modalData, storeTag: target })
    setTagList(copy)
  }

  const changeRequired = (key, value) => {
    const copy = cloneDeep(modalData)
    copy[key].value = value
    copy[key].isInvalid = checkInvalid(key, value)
    setModalData(copy)
  }

  const checkInvalid = (key, value = '') => {
    let res = true;
    // const target = modalData[key]
    switch (key) {
      case 'name':
        res = validator.isLength(value, { min: 1, max: 64 })
        break;
      default:
        res = true
    }
    return !res
  }

  const checkFormInvalid = () => {
    const checkList = [{ key: 'name', value: true },]
    let res = false
    for (const item of checkList) {
      const value = item.key ? modalData[item.key]?.value : null
      if (checkInvalid(item.key, value)) {
        res = true;
        break;
      }
    }
    return res
  }

  const saveFormat = () => {
    const obj = {
      name: modalData.name.value,
      organizationId: modalInfo.organizationId,
      storeTagId: modalData.storeTag.value
    }

    const parentTagAction = {
      type: 'onChange',
      originId: null,
      targetId: null
    }
    if (!modalInfo.isCreate) {
      obj.id = modalInfo.targetTag.id
      if (obj.storeTagId !== modalInfo.targetTag.parentStoreTagId) {
        if (isNil(obj.storeTagId)) {
          parentTagAction.type = 'remove'
          parentTagAction.originId = modalInfo.targetTag.id
        } else if (isNil(modalInfo.targetTag.parentStoreTagId)) {
          parentTagAction.type = 'add'
          parentTagAction.targetId = obj.storeTagId
        } else {
          parentTagAction.type = 'move'
          parentTagAction.originId = modalInfo.targetTag.parentStoreTagId
          parentTagAction.targetId = obj.storeTagId
        }
      }
    }
    return { parentTagAction, obj }
  }

  const submit = async () => {
    try {
      dispatch(uiActions.showModalSpinner());
      const copyMsg = cloneDeep(defaultMessages)
      const { parentTagAction, obj } = saveFormat()

      let res = null
      if (modalInfo.isCreate) {
        res = await storeTagService.createSiteTag(obj)
      } else {
        let tagRes = null
        const data = { ids: [obj.id] }
        if (parentTagAction.type === 'add') {
          tagRes = await storeTagService.addTag(parentTagAction.targetId, data)
        } else if (parentTagAction.type === 'remove') {
          tagRes = await storeTagService.removeTag(parentTagAction.originId, data)
        } else if (parentTagAction.type === 'move') {
          data.storeTagId = parentTagAction.targetId
          tagRes = await storeTagService.moveTag(parentTagAction.originId, data)
        } else {
          // no change
        }
        if (tagRes?.error) {
          copyMsg.error = tagRes.error.code
          setMultiMessages(copyMsg)
          return
        }
        res = storeTagService.updateSiteTag(obj.id, obj)
      }
      if (res.error) {
        copyMsg.error = res.error.code
        setMultiMessages(copyMsg);
        return
      }

      submitModal({ reload: true })
      closeModal()
    } catch (error) {
      console.debug(error)
    } finally {
      dispatch(uiActions.hideModalSpinner());
    }
  }

  const closeModal = () => {
    setMultiMessages(cloneDeep(defaultMessages));
    handleModals({ modal: 'tag', status: false })
  };

  useEffect(() => {
    init();
  }, [modalStatus?.tag?.status]);

  return (
    <ModalContainer
      modalWidthType='modal-500px'
      openModal={modalStatus.tag.status}
      closeModal={() => closeModal()}
    >
      {showModalSpinner && <SpinnerForModal />}
      <div className='header'>
        <div className='title'>{t(modalInfo.isCreate ? 'cd5ff8bec4' : 'cffa3aa8fc')}</div>
      </div>
      <div className={`body ${modalStyle['create-site-tag-container']}`}>
        <MessageBoxGroup
          messages={multiMessages}
          ErrorMessagesType='es'
          WarningMessagesType='i18n'
          onClose={type => setMultiMessages({ ...multiMessages, [type]: null })}
        />
        <Row>
          <Col>
            <div className='modal-form-title required'>{t('ce3f497740')}</div>
            <div className='modal-form-field'>
              <Input
                placeholder={t('7563cde047')}
                value={modalData.name.value}
                onChange={e => { changeRequired('name', e.target.value) }}
                isInvalid={modalData.name?.isInvalid}
              />
            </div>
          </Col>
          <Col>
            <div className='modal-form-title'>{t('74542af02a')}</div>
            <div className='modal-form-field'>
              <DropdownWithItem
                id="site-tag-dropdown"
                type="normal"
                selectedItem={modalData.storeTag}
                itemList={tagList}
                dropDownMenuStyle={{ maxHeight: '300px', overflow: 'auto' }}
                onClick={(item) => { changeTag(item) }}
              />
            </div>
          </Col>
        </Row>
        <div className={modalStyle['site-tag-hint']}>{t('b8f44cfa07')}</div>

      </div>
      <div className='footer'>
        <Button
          label='4a53b84974'
          className='btn-cancel'
          onClick={() => closeModal()}
        />
        <Button
          label='c9cc8cce24'
          className='btn-submit'
          disabled={checkFormInvalid()}
          onClick={() => submit()}
        />
      </div>
    </ModalContainer>
  );
};

export default OrgManagementSiteTagModal;
